import React from "react";
import PropTypes from "prop-types";
import { getNewRoomPath } from "Sections/Room/routes";
import ListRoomApartmentMapping from "./list-room-apartment-mapping";

const ListRoomApartmentRoute = ({ router }) => {
  const redirectToListRoom = () => {
    router.push(getNewRoomPath());
  };

  return <ListRoomApartmentMapping onListRoom={redirectToListRoom} />;
};

ListRoomApartmentRoute.propTypes = {
  router: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};
export default ListRoomApartmentRoute;
